<template>
  <div class="registration">
      <div class="mt_bl" v-show="!codeView">
            <v-text-field
                label="Номер телефона"
                class="inpt"
                hide-details="auto"
                name="phone"
                v-model.trim="phone"
            >
            <p slot="prepend" class="number_phone">
                +7
            </p>
            </v-text-field>
            <div class="error" v-if="$v.phone.$dirty && !$v.phone.required">Поле телефон обязателен к заполнению</div>
            <div class="error" v-if="!$v.phone.minLength">Поле телефон минимальная длина 10 цифр.</div>
            <div class="error" v-if="!$v.phone.maxLength">Поле телефон максимальная длина 10 цифр.</div>
            <div class="error" v-if="!$v.phone.numeric">Поле телефон введите только цифры</div>
          
            <button 
                class="btn" 
                @click="registarations"
            >
                <span v-show="!viewLoader">
                    Отпрaвить
                </span>
                <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate size="24"></v-progress-circular>
            </button>
            <a @click="reg">
                Вход
            </a>
      </div>
      <div class="mt_bl" v-show="codeView">
            <div v-show="!viewSucces" class="sms_confirm">
                <p>На ваш телефон отправлено код смс</p>
                <CodeInput 
                    :loading="false" 
                    :fieldWidth="56"
                    class="input_verif"
                    v-on:change="onChange" 
                    :autoFocus="true"
                />
                <CodeInput 
                    :loading="false" 
                    :fieldWidth="35"
                    :fieldHeight="35"
                    class="input_verif_mob"
                    v-on:change="onChange" 
                    :autoFocus="true"
                />
                <button class="btn" :disabled="isDisabled" @click="smsConfirm">Проверить</button>
                <a @click="codeReview">
                    Назад
                </a>
            </div>
            
            <div v-show="viewSucces" class="success_registaration">
                <p>
                    Вы успешно изменили пароль! {{dataSucess}}  
                </p>
                <a class="success_registaration_auth" @click="reg">
                    Вход
                </a>
            </div>
      </div>
  </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";
import axios from 'axios'
import { required, minLength, maxLength, numeric, } from 'vuelidate/lib/validators'

export default {
  name: 'registration',
  components: { CodeInput },
  validations: {
      phone: {
          required, minLength: minLength(10), maxLength: maxLength(10), numeric
      },
  },
  data () {
      return {
        phone: '',
        codeView: false,
        viewLoader: false,
        isDisabled: true,
        code: '',
        viewSucces: false,
        dataSucess: ''
      }
  },
  methods: {
    codeReview() {
        this.codeView = false
    },
    reg() {
        this.$emit('signInReset')
        this.viewSucces = false
    },
    registarations () {
        if (this.$v.$invalid) {
            this.$v.$touch()
            return 
        } else {
            this.viewLoader = true
            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: 'https://ecodom04.com/rest/api/user/password-reset-sms',
                data: {
                    phone: '7' + this.phone,
                }
            })
            .then((response) => {
                this.viewLoader = false
                console.log(response)
                if (response.data.msg == "Phone not exist!") {
                    this.$toasted.show('Номер не зарегистрирован!').goAway(2000)
                }
                if (response.data.sms_code != "") {
                    this.codeView = true
                } 
            })
            .catch((error) => {
                console.log(error);
            });
        }
         
    },
    smsConfirm() {
        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: 'https://ecodom04.com/rest/api/user/password-reset',
            data: {
                phone: '7' + this.phone,
                sms_code: this.code
            }
        })
        .then((response) => {
            if (response.data.msg == "Sms code not valid!") {
                this.$toasted.show('Не верный код').goAway(2000)
                return false
            } else {
                this.phone = ''
                this.viewSucces = true
                this.dataSucess = response.data.msg
            }
               
            
        })
        .catch((error) => {
            console.log(error);
        });
    },
    onChange(v) {
        if (v.length == 6) {
            this.code = v
            this.isDisabled = false
        }
    },
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.registration {
    width: 100%;

    .mt_bl {
        .number_phone {
            position: relative;
            left: 0;
            font-size: 16px;
            top: 4px;
            font-weight: bold;
            margin-right: 5px;
        }
        .input_verif {
            display: block;
            margin: 0 auto;
            @media (max-width: @baseMedia) {
                display: none;
            }
        }
        .input_verif_mob {
            display: none;
            @media (max-width: @baseMedia) {
                display: block;
            }
        }
        .success_registaration {
            width: 100%;
            padding-top: 20px;
            padding-bottom: 20px;
            text-align: center;
            p {
                font-size: 16px;
            }
            .success_registaration_auth {
                color: #6b8e01;
                font-weight: bold;
                font-size: 17px;
            }
        }
        p {
            font-size: 14px;
            margin-bottom: 10px;
        }
        a {
            text-align: center;
            font-size: 14px;
            text-transform: uppercase;
            color: #000;
            cursor: pointer;
            display: block;
            margin: 0 auto;
        }
        .inpt {
            width: 100%;
        }
        .error {
            color: red;
            font-size: 11px;
            margin-top: 4px;
        }
        .btn {
            width: 100%;
            margin-top: 15px;
            margin-bottom: 10px;
            height: 40px;
            background: #90b913;
            color: #fff;
            text-transform: uppercase;
            font-size: 14px;
            &:hover {
                background: #8ba245;
            }
            .loader__color {
                color: #fff;
            }
        }
    }
}
</style>